module.exports = "pegasus_template/assets/circle-youtube.png";